import styled from "@emotion/styled";
import { Switch } from "antd";

const StyledSwitch = styled(Switch)(({ theme }) => ({
  "&.ant-switch.ant-switch-checked": {
    background: `${theme.color.green} !important`,
  },
  height: "3.2rem",
  width: "5.6rem",
  "&.ant-switch": {
    minWidth: "5.6rem",
    // 스위치 핸들(동그라미) 크기 조절
    ".ant-switch-handle": {
      width: "2.8rem",
      height: "2.8rem",
      top: "0.2rem",
      left: "0.2rem",
      "&::before": {
        borderRadius: "50%",
      },
    },
    // 켜졌을 때 핸들 위치 조절
    "&.ant-switch-checked .ant-switch-handle": {
      left: "calc(100% - 3rem)", // 핸들 크기 + 여백
    },
    // 배경 크기 조절
    ".ant-switch-inner": {
      height: "3.2rem",
    },
  },
}));

const BaseSwitch = ({
  checked,
  onChange,
}: {
  checked: boolean;
  onChange: (checked: boolean) => void;
}) => {
  return <StyledSwitch checked={checked} onChange={onChange} />;
};

export default BaseSwitch;
